import { render } from "./IconProductsReports.vue?vue&type=template&id=8cf09e78"
import script from "./IconProductsReports.vue?vue&type=script&lang=js"
export * from "./IconProductsReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__